import React, { useCallback, type Dispatch } from 'react';
import { Button } from 'components/ui/button';
import { Col, Form, Row } from 'react-bootstrap-5';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import type { ContactEmail } from 'bundles/connect/types';

type EmailsProps = {
  emails: ContactEmail[];
  onSet: Dispatch<React.SetStateAction<ContactEmail[]>>;
}

export default function Emails({ emails, onSet }: EmailsProps) {
  const handleChange = useCallback((idx, changes) => {
    onSet(emails.map((email, index) => {
      if (index == idx) {
        return {
          ...email,
          ...changes
        };
      }

      return email;
    }));
  }, [emails]);

  const handleRemove = useCallback((idx) => {
    onSet(emails.map((email, index) => {
      if (index == idx) {
        return {
          ...email,
          _destroy: true
        };
      }

      return email;
    }));
  }, [emails]);

  const handleNew = useCallback(() => {
    onSet([...emails, { } as ContactEmail]);
  }, [emails]);

  return (
    <div>
      <Row className="align-items-center">
        <Col><Form.Label className="my-0">Email Addresses</Form.Label></Col>
        <Col xs="auto">
          <Button label="+ Add New Email" size="sm" variant="secondary" onClick={handleNew} />
        </Col>
      </Row>
      <div className="d-flex flex-column gap-2 mt-2">
        {emails.map((email, index) => {
          if (email._destroy) return;

          return (
            <div className="d-flex" key={`email-address-${index}`}>
              <Form.Control
                placeholder="Email Address"
                required
                value={email.email}
                onChange={e => handleChange(index, { email: e.target.value })}
              />
              <Button className="text-danger" icon={faTrash} variant="ghost" onClick={() => handleRemove(index)} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
